import React from 'react';
import { INavLink, INavProps, Nav } from '@fluentui/react';
import { useNavigator } from '../../services/navigation';

export const BwjNav: React.FunctionComponent<INavProps> = (props) => {
    const originalOnLinkClick = props.onLinkClick;
    const p = {...props};
    const navigator = useNavigator();
  
    p.onLinkClick = (ev?: React.MouseEvent<HTMLElement, MouseEvent>, item?: INavLink) => {
      if(!!originalOnLinkClick) {
        originalOnLinkClick(ev, item);
        if(ev?.isPropagationStopped() ?? false) { return; }
      }

      if(!!item) {
        ev?.preventDefault();
        ev?.stopPropagation();
        navigator.goTo(item.url);
      }
    };
  
  return (
    <Nav {...p} />
  );
};
